var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBfiEmployeeCertainLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5913 27.5289C25.5913 29.7221 19.9541 31.5 13.0002 31.5C6.04637 31.5 0.40918 29.7221 0.40918 27.5289C0.40918 25.8061 3.88831 24.3397 8.75137 23.7899C9.33412 24.5735 9.90281 25.3142 10.4326 25.9924C8.58218 26.2554 7.31387 26.7936 7.31387 27.415C7.31387 28.2954 9.85974 29.0091 13.0002 29.0091C16.1407 29.0091 18.6866 28.2954 18.6866 27.415C18.6866 26.7942 17.4206 26.2563 15.5728 25.9931C16.1057 25.3139 16.6767 24.5736 17.2612 23.7913C22.1179 24.3421 25.5913 25.8074 25.5913 27.5289ZM13.0002 0.5C7.49949 0.5 3.04024 4.95925 3.04024 10.46C3.04024 15.0312 9.6798 23.4734 12.7566 27.3142C12.8178 27.3906 12.9021 27.4311 13.0002 27.4311C13.0981 27.4312 13.1824 27.3908 13.2437 27.3145C16.1931 23.6392 22.9602 15.1567 22.9602 10.46C22.9602 4.95925 18.501 0.5 13.0002 0.5ZM13.0002 5.229C15.8825 5.229 18.2191 7.56563 18.2191 10.4479C18.2191 13.3302 15.8826 15.6667 13.0002 15.6667C10.1179 15.6667 7.78137 13.3302 7.78137 10.4479C7.78137 7.56563 10.1179 5.229 13.0002 5.229Z",
    fill: "#23539A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfiEmployeeCertainLocation);
export default __webpack_public_path__ + "static/media/BFIEmployeeCertainLocation.9d13a9b9efed48bf7e4f902fea84f27c.svg";
export { ForwardRef as ReactComponent };